export default class TreffToolTip {
  constructor() {
    $('body').tooltip({
      selector: '.treff-tooltip',
      template:
        '<div data-test="test" class="tt tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/trefftooltip.js